<template>
  <footer class="footer" role="footer">
    <div class="grid grid--flex footer__grid">
      <div class="grid__cell grid__cell--2 footer__col">
        <contact-form></contact-form>
        <contact></contact>
      </div>

      <div class="grid__cell grid__cell--2 footer__col footer__col">
        <our-partners></our-partners>

        <ul class="footer__navigation">
          <li class="footer__navigation__item">
            NAIH-118898/2017.
          </li>

          <li class="footer__navigation__item">
            BP/0701/7992-1/2017- 1081
          </li>
        </ul>
      </div>
    </div>

    <div class="footer__copyright">&copy; Minden jog fenntartva 2017 Melostock</div>
    <img src="../assets/partners/szechenyi2020.png" alt="Széchenyi 2020" class="footer__szechenyi-logo">
  </footer>
</template>

<script>
  import Contact from './Contact.vue'
  import ContactForm from './ContactForm.vue'
  import OurPartners from './OurPartners'

  export default {
    components: {
      Contact,
      ContactForm,
      OurPartners
    }
  }
</script>



// WEBPACK FOOTER //
// PageFooter.vue?123168d1